import type { StandardLayoutStyles } from '../../ThemeTypes';
import colors from '../colors';
import fonts from '../fonts';

const standard: StandardLayoutStyles = {
  mainContentColumn: {
    paddingLeft: '30px !important',
  },

  shouldTextsBeItalic: {
    yourOptimisation: false,
    tariffRecommender: false,
  },

  portal: {
    zIndex: 1000,
    bottom: 0,
    left: 0,
    right: 0,
    position: 'fixed',
  },
  appCtaSpace: {
    height: '300px',
    color: colors.white,
    fontSize: '40px',
    fontWeight: fonts.fontWeights.bold,
  },
  mediaQueries: {
    '${max.md}': {
      appCtaSpace: {
        height: '250px !important',
      },
      appstoreFooter: {
        '.col': {
          fontSize: '32px',
        },
        img: {
          width: '100%',
          maxWidth: '240px',
        },
      },
    },
    '${max.sm}': {
      appCtaSpace: {
        height: '250px !important',
      },
      appstoreFooter: {
        '.col': {
          fontSize: '26px',
        },
      },
    },
  },
  navbarToggle: {
    border: 'none',
    background: 'transparent !important',
    '&:hover': {
      background: 'transparent !important',
    },
    '.icon-bar': {
      width: '22px',
      transition: 'all 0.2s',
      display: 'block',
      height: '2px',
      borderRadius: '1px',
      backgroundColor: colors.white,
    },
    '.top-bar': {
      transform: 'rotate(45deg)',
      transformOrigin: '10% 10%',
    },
    '.middle-bar': {
      opacity: 0,
      marginTop: '4px',
    },
    '.bottom-bar': {
      transform: 'rotate(-45deg)',
      transformOrigin: '10% 90%',
      marginTop: '4px',
    },
  },
  collapsed: {
    '.top-bar': {
      transform: 'rotate(0)',
    },
    '.middle-bar': {
      opacity: 1,
    },
    '.bottom-bar': {
      transform: 'rotate(0)',
    },
  },

  savings: {
    tariffKeyTable: {
      backgroundColor: colors.primary,
      backgroundImage: 'none',
    },
    rateDescription: {
      fontSize: '12px',
      lineHeight: '16px',
    },
  },
};

export default standard;
